import handshake from "../../../../../../../images/handshake.svg";
import brokenCard from "../../../../../../../images/broken-card.svg";
import { Row } from "antd";

type NoStatusProps = {
  status: string;
};

export const NoStatus = ({ status }: NoStatusProps) => {
  return (
    <Row className="w-100 d-block">
      <Row className="w-100 justify-center">
        <img
          src={status === "Paid Off" ? handshake : brokenCard}
          alt="Account status"
        />
      </Row>
      <Row className="w-100 justify-center">
        <p className="my-0">
          Account has been <span className="text-md w-500">{status}</span>
        </p>
      </Row>
    </Row>
  );
};
